import { connect } from 'react-redux';
import { resetOrder } from '../order';
import IsSpinning from '../../app/containers/IsSpinning';
import Spinner from '../../app/components/Spinner';
import OrderSidebar from './OrderSidebar';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import {ActiveTenantRequired} from '../../../lib/api/components/ActiveTenantRequired';
import ImmutablePropTypes from 'react-immutable-proptypes';
import routes from '../routes';
import {withRouter} from "react-router-dom";
import GlobalError from "../../app/components/GlobalError";
import Helmet from 'react-helmet';
import {injectIntl, intlShape} from "react-intl";
import {filterEnabledSteps} from "../steps";

@injectIntl
export class Order extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    componentWillUnmount() {
        this.props.dispatch(resetOrder());
    }

    render() {
        const { dispatch, session, steps, tenant } = this.props;
        const { formatMessage } = this.props.intl;

        const enabledSteps = filterEnabledSteps(steps);

        return (
            <Page>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.new_order' })} />
                <Page.Header />
                <GlobalError />
                <SessionRequired dispatch={dispatch} session={session}>
                    <ActiveTenantRequired dispatch={dispatch} session={session} tenant={tenant}>
                        <Page.Body sidebar={<OrderSidebar />}>
                            <Page.Section>
                                {routes(enabledSteps)}
                                <IsSpinning id='order'>
                                    <Spinner />
                                </IsSpinning>
                            </Page.Section>
                        </Page.Body>
                    </ActiveTenantRequired>
                </SessionRequired>
                <Page.Footer />
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
    steps: state.steps,
    tenant: state.tenant,
}))(Order));
